<template>
  <transition name="toast-slide">
    <div
      v-if="toast"
      :class="['cart-toast', toast.type]"
      @click="dismiss"
    >
      <span class="cart-toast__icon" v-if="toast.type === 'success'">✓</span>
      <span class="cart-toast__icon" v-else>✕</span>
      <span class="cart-toast__message">{{ toast.message }}</span>
      <button class="cart-toast__close" @click.stop="dismiss">×</button>
    </div>
  </transition>
</template>

<script>
import cartService from '@/cart'

export default {
  name: 'CartToast',
  computed: {
    toast() {
      return cartService.state.toast
    }
  },
  methods: {
    dismiss() {
      cartService.dismissToast()
    }
  }
}
</script>

<style scoped>
.cart-toast {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-radius: 10px;
  font-family: 'Rajdhani', sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(12px);
  min-width: 260px;
  max-width: 400px;
}

.cart-toast.success {
  background: linear-gradient(135deg, rgba(46, 204, 113, 0.9), rgba(39, 174, 96, 0.85));
  border: 1px solid rgba(46, 204, 113, 0.4);
}

.cart-toast.error {
  background: linear-gradient(135deg, rgba(231, 76, 60, 0.9), rgba(192, 57, 43, 0.85));
  border: 1px solid rgba(231, 76, 60, 0.4);
}

.cart-toast__icon {
  font-size: 18px;
  flex-shrink: 0;
}

.cart-toast__message {
  flex: 1;
}

.cart-toast__close {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  cursor: pointer;
  padding: 0 4px;
  flex-shrink: 0;
  transition: color 0.2s;
}

.cart-toast__close:hover {
  color: #fff;
}

.toast-slide-enter-active {
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.toast-slide-leave-active {
  transition: all 0.3s ease-in;
}

.toast-slide-enter,
.toast-slide-leave-to {
  opacity: 0;
  transform: translateX(80px);
}

@media (max-width: 480px) {
  .cart-toast {
    top: 12px;
    right: 12px;
    left: 12px;
    min-width: auto;
    max-width: none;
    font-size: 14px;
    padding: 12px 16px;
  }
}
</style>
